

















































import {Component, Watch} from 'vue-property-decorator';
import VueElementLoading from 'vue-element-loading';
import '../user-management.scss';
import {IKeyCloakUser, IEbkDohItem} from '../user-management-int';
import BaseUserLink from '../base-user-link';
import { umFetch } from '../services/umFetch';

@Component({
    components: {
        'loading': VueElementLoading
    }
})
export default class KatUserData extends BaseUserLink {
    private katBase: any = [];
    private katList: any[] = [];
    private selectedUserFgrList: IEbkDohItem[] = [];
    private loading = false;

    @Watch('selectedUser')
    async onPropertyChanged(value: IKeyCloakUser, oldValue: IKeyCloakUser) {
        this.loading = true;
        if (oldValue !== null) {
            this.selectedUserFgrList = [];
            this.katList = [...this.katBase];
            this.katList.sort((a, b) => a.kat - b.kat);
        }
        await this.selectUser(value);
        this.loading = false;
    }

    private async loadKat() {
        try {
            const response = await fetch('/api-py/get-dict-doh-childs-by-parent/0');
            this.katBase = await response.json() as IEbkDohItem;
            this.katList = [...this.katBase];
        } catch (error) {
            this.makeToast('danger', 'Ошибка загрузки категорий', error.toString());
        }
    }

    public async selectUser(user: IKeyCloakUser) {
        this.selectedUser = user;
        await this.loadUserKat(user);
        if (this.selectedUser !== null) {
            for (const item of this.selectedUserFgrList) {
                for (const it of this.katList) {
                    if (it.kat === item.kat) {
                        const ind = this.katList.indexOf(it);
                        this.katList.splice(ind, 1);
                    }
                }
            }
        }
    }

    removeAllKat() {
        for (const abpListElement of this.selectedUserFgrList) {
            this.katList.push(abpListElement)
        }
        this.katList.sort((a, b) => a.kat - b.kat);
        this.selectedUserFgrList = []
        this.saveUserFgrData(this.selectedUser);
    }

    addAllKat() {
        for (const abpListElement of this.katList) {
            if (!this.selectedUserFgrList.find(value => value.id === abpListElement.id)) this.selectedUserFgrList.push(abpListElement)
        }
        this.selectedUserFgrList.sort((a, b) => a.kat - b.kat);
        this.katList = []
        this.saveUserFgrData(this.selectedUser);
    }

    private addFgrToSelectedUser(kat: IEbkDohItem, save: boolean) {
        if (this.selectedUserFgrList.indexOf(kat) < 0) {
            this.selectedUserFgrList.push(kat);
            const ind = this.katList.indexOf(kat);
            this.katList.splice(ind, 1);
        }
        this.selectedUserFgrList.sort((a, b) => a.kat - b.kat);
        if (save) {
            this.saveUserFgrData(this.selectedUser);
        }
    }

    private removeFgrFromSelectedUser(kat: IEbkDohItem, save: boolean) {
        const ind = this.selectedUserFgrList.indexOf(kat);
        this.selectedUserFgrList.splice(ind, 1);
        this.katList.push(kat);
        this.katList.sort((a, b) => a.kat - b.kat);
        if (save) {
            this.saveUserFgrData(this.selectedUser);
        }
    }

    private async saveUserFgrData(user: IKeyCloakUser) {
        const katList: any = [];
        // массив выбраных ФГ для базы
        for (const item of this.selectedUserFgrList) {
            const d = {
                kat: item.kat
            };
            katList.push(d);
        }
        // объект для передачи
        if (user !== null) {
            const saveData = {
                user_id: user?.id,
                katList: katList
            };
            try {
               await umFetch('/api-py/save-user-kat', {
             method: 'POST',
             headers: {
              'Content-Type': 'application/json;charset=utf-8',
              'Authorization': `Bearer ${this.$store.getters.token}`
            },
             body: JSON.stringify(saveData)
            });

            } catch (error) {
                this.makeToast('danger', 'Ошибка сохранения данных: ' + user.id, error.toString());
            }
        }
    }

    private async loadUserKat(user: IKeyCloakUser) {
        if (user !== null)
            try {
                this.selectedUserFgrList = [];
                const response = await fetch('/api-py/user-kat/' + user?.id);
                const data = await response.json();
                for (const item of data) {
                    for (const t of this.katList) {
                        if (item.kat === t.kat) {
                            this.addFgrToSelectedUser(t, false);
                        }
                    }
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки данных категорий : ' + user.id, error.toString());
            }
    }

    public async mounted() {
        await this.loadKat();
        if (this.selectedUser !== null) {
            this.loadUserKat(this.selectedUser);
        }
    }
}
